// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-loader {\r\n    animation: loader 1s infinite;\r\n    display: flex;\n}\n@keyframes loader {\nfrom {\r\n        transform: rotate(0);\n}\nto {\r\n        transform: rotate(360deg);\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
